import DrawerHistoryIndex from './DrawerHistoryIndex';
import { connect } from 'react-redux';
import {
  mapStateToProps,
  mapDispatchToProps,
} from './DrawerHistoryIndex.state';

export default connect(mapStateToProps, mapDispatchToProps)(DrawerHistoryIndex);
